import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventRowNFL } from 'src/domains/sportsbook/shared/Components';
import { HomepageWidgetNFLHeader } from './HomepageWidgetNFLHeader';
import { HeroWidgetModelType } from 'src/api/config/cms_new/hero_widget/get_hero_widget_active';
import { HeroWidgetItemState } from 'src/domains/layouts/webview/components/heroEvents/HeroWidgetItem.state';
import { HeroWidgetBanner } from 'src/domains/layouts/webview/components/heroEvents/HeroWidgetBanner';
import { EventListGroupEventItemType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';
import { HeroWidgetMainBanner } from 'src/domains/layouts/webview/components/heroEvents/HeroWidgetMainBanner';
import { useCommon } from 'src/domains/common/Common';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { NFLEventRow6PackState } from 'src/domains/sportsbook/webview/components/eventsList/eventRowNFL/EventRowNFL.state';
import { LanguagesState } from 'src/domains/layouts/state/languagesState/LanguagesState';
import { HomepageHeroWidgetNFLOutrights } from './HomepageWidgetNFLOutrights';

interface HomepageHeroWidgetNFLPropsType {
    heroWidgetItem: HeroWidgetModelType;
    smallEvent: EventListGroupEventItemType;
}

export const HomepageHeroWidgetNFL = observer(
    'HomepageHeroWidgetNFL',
    ({ heroWidgetItem, smallEvent }: HomepageHeroWidgetNFLPropsType): JSX.Element | null => {
        const { event_id, is_active_promo, title, subtitle, id, tc_text, tc_title } = heroWidgetItem;
        const common = useCommon();
        const starRouter = StarRouter.get(common);
        const breakpointsState = BreakpointsState.get(common);
        const languagesState = LanguagesState.get(common);

        const [eventRow6PackState] = useState(() => new NFLEventRow6PackState(event_id, languagesState));
        const [heroWidgetItemState] = useState(() => new HeroWidgetItemState(starRouter, heroWidgetItem));
        const { headerImages, promoImages, marketModel } = heroWidgetItemState;

        if (marketModel !== null) {
            return (
                <React.Fragment key={marketModel.id}>
                    <>
                        <HeroWidgetMainBanner
                            images={headerImages}
                            title={title}
                            subtitle={subtitle}
                        />
                        {eventRow6PackState.event?.eventType === 'outrights' ? (
                            <HomepageHeroWidgetNFLOutrights smallEvent={smallEvent} />
                        ) : (
                            <>
                                {breakpointsState.desktop.isBiggerOrEq === true ? <HomepageWidgetNFLHeader /> : null}
                                <EventRowNFL
                                    smallEvent={smallEvent}
                                    eventId={event_id}
                                />
                            </>
                        )}
                    </>
                    {is_active_promo ? (
                        <HeroWidgetBanner
                            withMargin={false}
                            banners={promoImages}
                            slug={`${id}-hero-promo`}
                            content={tc_text ?? ''}
                            title={tc_title ?? ''}
                        />
                    ) : null}
                </React.Fragment>
            );
        }
        return null;
    }
);
